import { useEffect } from "react"
import { useTranslation } from "react-i18next"

import { useLoginWithIDP } from "shared/lib/useLoginWithIDP"

import "./styles/_register-page.scss"

export function RegisterPage() {
  const { t } = useTranslation()
  const { loginAsVisitor } = useLoginWithIDP()

  useEffect(() => {
    if (loginAsVisitor) {
      loginAsVisitor({ redirectURL: window.location.origin })
    }
  }, [loginAsVisitor])

  return (
    <div className="register-page">
      <div className="register-page__content">
        <div className="register-page__loading">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">
              {t("Authentication.Register.Loading")}
            </span>
          </div>
          <p className="mt-3">
            {t("Authentication.Register.LoadingDescription")}
          </p>
        </div>
      </div>
    </div>
  )
}
